import { Button } from '@material-ui/core'
import React from 'react'

export interface ButtonWithPermissionsProps {
  disabled?: boolean
  size: any
  variant?: any
  color: any
  className?: any
  onClick: () => void
  hasPermission: boolean
}

const ButtonWithPermissions: React.FC<ButtonWithPermissionsProps> = ({
  hasPermission,
  ...props
}) => {
  return hasPermission ? <Button {...props}>{props.children}</Button> : null
}

export default ButtonWithPermissions
